import React from 'react'
import { Container, Background } from './Popup.styles'

interface PopupProps {
  opened: boolean
  onClose?: () => any
}

export default class Popup extends React.PureComponent<PopupProps | any> {
  render() {
    return (
      <Container className={this.props.opened ? 'opened' : ''}>
        <Background onClick={this.props.onClose} />
        {this.props.children}
      </Container>
    )
  }
}
